// extracted by mini-css-extract-plugin
export default {"team":"Team_team__dA-J5","h2":"Team_h2__gdEk8","members":"Team_members__oZd7L"};